import { render, staticRenderFns } from "./InviteePanel.vue?vue&type=template&id=0b86d5b2&scoped=true"
import script from "./InviteePanel.vue?vue&type=script&lang=js"
export * from "./InviteePanel.vue?vue&type=script&lang=js"
import style0 from "./InviteePanel.vue?vue&type=style&index=0&id=0b86d5b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86d5b2",
  null
  
)

export default component.exports